module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed",
    class: {
      'fixed-shadow': _vm.suspension
    }
  }, [_c('div', {
    staticClass: "main-header"
  }, [_c('div', {
    staticClass: "main-header-width"
  }, [_c('span', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Home'
      }
    }
  }, [_vm._v(_vm._s(_vm.headerName))])], 1), _vm._v(" "), _c('ul', {
    staticClass: "main-top-info"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Center'
      }
    }
  }, [_vm._v(_vm._s(_vm.account))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Order'
      }
    }
  }, [_c('i', {
    staticClass: "header-order-icon"
  }), _vm._v("订单\n          ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Wallet'
      }
    }
  }, [_c('i', {
    staticClass: "header-order-icon header-wallet-icon"
  }), _vm._v("我的钱包\n          ")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'DownloadList'
      }
    }
  }, [_c('i', {
    staticClass: "header-order-icon header-download-icon"
  }), _vm._v("下载列表\n          ")])], 1), _vm._v(" "), _c('li', {
    staticStyle: {
      "border": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Document'
      }
    }
  }, [_c('i', {
    staticClass: "header-order-icon header-document-icon"
  }), _vm._v("功能文档\n          ")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "main-search"
  }, [_c('div', {
    staticClass: "main-search-logo"
  }, [_c('router-link', {
    style: ({
      backgroundImage: 'url(' + _vm.logoUrl + ')'
    }),
    attrs: {
      "tag": "a",
      "to": {
        name: 'Home'
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "main-search-content",
    staticStyle: {
      "width": "650px"
    }
  }, [_c('ul', {
    staticClass: "main-search-type"
  }, _vm._l((_vm.tab), function(item, index) {
    return _c('li', {
      class: {
        'select': item.position == _vm.position
      },
      attrs: {
        "data-id": index
      },
      on: {
        "click": _vm.searchType
      }
    }, [_vm._v("\n          " + _vm._s(item.tabtext))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "main-search-input"
  }, [(_vm.tab[0].isShow) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入商品名称"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm(_vm.tab[0].position)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]) : (_vm.tab[1].isShow) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "type": "text",
      "placeholder": "输入商品名称"
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm(_vm.tab[1].position)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]) : _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keyword),
      expression: "keyword"
    }],
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.keyword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keyword = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "main-search-btn",
    attrs: {
      "tag": "div",
      "to": {
        name: 'Category',
        query: {
          levelOne: '',
          levelTwo: '',
          levelThree: '',
          keyWord: _vm.keyword,
          selectType: _vm.selectType,
          brandId: '',
          position: _vm.position
        }
      }
    }
  }, [_vm._v("搜\n          索")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-spp-car",
    staticStyle: {
      "width": "300px",
      "text-align": "right"
    }
  }, [_c('router-link', {
    staticClass: "main-spp-car-shape",
    staticStyle: {
      "display": "inline-block",
      "margin-right": "10px"
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'PriceLibraryGoods'
      }
    }
  }, [_c('i', {
    staticClass: "main-library-icon"
  }), _vm._v("\n        报价篮子\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "main-spp-car-shape",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'Shelves'
      }
    }
  }, [_c('i', {
    staticClass: "main-car-icon"
  }), _vm._v("\n        我的货架\n        ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a0a05c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 513
// module chunks = 1